import { withStyles } from '@material-ui/core';

import AsyncButton from './component';
import styles from './styles';

export default withStyles(styles)(AsyncButton);
